import React from "react";

export const Text = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="cw-body-base md:cw-body-lg cw-text-muted cw-pb-3 cw-mb-6 cw-w-full md:cw-w-[600px] cw-text-center">
      {children}
    </div>
  );
};
